import React from 'react';
import useReveal, { reveal } from '../../hooks/useReveal';
import { PLATFORM_STATS } from '../../data/site';

/*
  Sits directly under the hero. Deliberately not inside it: the hero carries the
  value proposition and the primary CTA, and social proof is its own moment.

  There is no customer logo wall here because AtadaBoard has no cleared school
  logos in the repository. When real logos exist, drop them into the marked
  slot below rather than adding invented marks.
*/
const TrustBand = () => {
  const [ref, isVisible] = useReveal({ threshold: 0.4 });

  return (
    <section className="ab-trust" aria-label="AtadaBoard at a glance" ref={ref}>
      <div className={`ab-shell ab-trust__inner ${reveal(isVisible)}`}>
        <p className="ab-trust__line">Trusted by schools across Ghana</p>

        <dl className="ab-trust__stats">
          {PLATFORM_STATS.map((stat) => (
            <div key={stat.label} className="ab-trust__stat">
              <dt className="ab-num ab-trust__value">{stat.value}</dt>
              <dd className="ab-trust__label">{stat.label}</dd>
            </div>
          ))}
        </dl>

        {/* TODO: school logo wall, once cleared logo files are added to src/assets. */}
      </div>

      <style jsx>{`
        .ab-trust {
          border-block: 1px solid var(--ab-line);
          background: var(--ab-paper);
          padding-block: clamp(1.75rem, 3vw, 2.5rem);
        }

        .ab-trust__inner {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: clamp(1.5rem, 4vw, 3rem);
        }

        .ab-trust__line {
          font-size: 0.9375rem;
          font-weight: 600;
          color: var(--ab-ink-3);
        }

        .ab-trust__stats {
          display: flex;
          flex-wrap: wrap;
          gap: clamp(1.75rem, 4vw, 3.75rem);
          margin: 0;
        }

        .ab-trust__stat { display: flex; align-items: baseline; gap: 0.5rem; }

        .ab-trust__value {
          font-family: var(--ab-font-display);
          font-size: 1.5rem;
          font-weight: 600;
          letter-spacing: -0.02em;
          color: var(--ab-blue);
        }

        .ab-trust__label {
          margin: 0;
          font-size: 0.9375rem;
          color: var(--ab-ink-2);
        }

        @media (max-width: 860px) {
          .ab-trust__stats { gap: 1.25rem 2rem; }
          .ab-trust__stat { flex-direction: column; gap: 0; }
          .ab-trust__label { font-size: 0.875rem; }
        }
      `}</style>
    </section>
  );
};

export default TrustBand;
